import type {
  LifestyleSubstanceFrequency,
  LifestyleSubstanceType,
} from "@louise/medical-history/basic-info/types";

export const SUBSTANCE_OPTIONS: {
  id: LifestyleSubstanceType;
  labelKey: string;
}[] = [
  {
    id: "alcohol",
    labelKey: "med_history.lifestyle.substances.substance_type.alcohol",
  },
  {
    id: "coffee",
    labelKey: "med_history.lifestyle.substances.substance_type.coffee",
  },
  {
    id: "cigarettes",
    labelKey: "med_history.lifestyle.substances.substance_type.cigarettes",
  },
  {
    id: "vape",
    labelKey: "med_history.lifestyle.substances.substance_type.vape",
  },
  {
    id: "snus",
    labelKey: "med_history.lifestyle.substances.substance_type.snus",
  },
  {
    id: "cannabis",
    labelKey: "med_history.lifestyle.substances.substance_type.cannabis",
  },
  {
    id: "cbd",
    labelKey: "med_history.lifestyle.substances.substance_type.cbd",
  },
  {
    id: "cocaine",
    labelKey: "med_history.lifestyle.substances.substance_type.cocaine",
  },
  {
    id: "hookah",
    labelKey: "med_history.lifestyle.substances.substance_type.hookah",
  },
  {
    id: "other",
    labelKey: "med_history.lifestyle.substances.substance_type.other",
  },
];

export const SUBSTANCE_FREQUENCY_OPTIONS: {
  id: LifestyleSubstanceFrequency;
  labelKey: string;
}[] = [
  {
    id: "yearly_or_less",
    labelKey:
      "med_history.lifestyle.substances.substance_frequency.yearly_or_less",
  },
  {
    id: "monthly_or_less",
    labelKey:
      "med_history.lifestyle.substances.substance_frequency.monthly_or_less",
  },
  {
    id: "weekly_or_less",
    labelKey:
      "med_history.lifestyle.substances.substance_frequency.weekly_or_less",
  },
  {
    id: "daily",
    labelKey: "med_history.lifestyle.substances.substance_frequency.daily",
  },
  {
    id: "stopped",
    labelKey: "med_history.lifestyle.substances.substance_frequency.stopped",
  },
];

export const SUBSTANCE_DETAIL_COPY: Record<
  LifestyleSubstanceType,
  { titleKey: string; contextLabelKey: string; quantityLabelKey: string }
> = {
  alcohol: {
    titleKey: "med_history.lifestyle.substances.substance_title.alcohol",
    contextLabelKey:
      "med_history.lifestyle.substances.substance_context_label.alcohol",
    quantityLabelKey:
      "med_history.lifestyle.substances.substance_quantity_label.alcohol",
  },
  coffee: {
    titleKey: "med_history.lifestyle.substances.substance_title.coffee",
    contextLabelKey:
      "med_history.lifestyle.substances.substance_context_label.coffee",
    quantityLabelKey:
      "med_history.lifestyle.substances.substance_quantity_label.coffee",
  },
  cigarettes: {
    titleKey: "med_history.lifestyle.substances.substance_title.cigarettes",
    contextLabelKey:
      "med_history.lifestyle.substances.substance_context_label.cigarettes",
    quantityLabelKey:
      "med_history.lifestyle.substances.substance_quantity_label.cigarettes",
  },
  vape: {
    titleKey: "med_history.lifestyle.substances.substance_title.vape",
    contextLabelKey:
      "med_history.lifestyle.substances.substance_context_label.vape",
    quantityLabelKey:
      "med_history.lifestyle.substances.substance_quantity_label.vape",
  },
  snus: {
    titleKey: "med_history.lifestyle.substances.substance_title.snus",
    contextLabelKey:
      "med_history.lifestyle.substances.substance_context_label.snus",
    quantityLabelKey:
      "med_history.lifestyle.substances.substance_quantity_label.snus",
  },
  cannabis: {
    titleKey: "med_history.lifestyle.substances.substance_title.cannabis",
    contextLabelKey:
      "med_history.lifestyle.substances.substance_context_label.cannabis",
    quantityLabelKey:
      "med_history.lifestyle.substances.substance_quantity_label.cannabis",
  },
  cbd: {
    titleKey: "med_history.lifestyle.substances.substance_title.cbd",
    contextLabelKey:
      "med_history.lifestyle.substances.substance_context_label.cbd",
    quantityLabelKey:
      "med_history.lifestyle.substances.substance_quantity_label.cbd",
  },
  cocaine: {
    titleKey: "med_history.lifestyle.substances.substance_title.cocaine",
    contextLabelKey:
      "med_history.lifestyle.substances.substance_context_label.cocaine",
    quantityLabelKey:
      "med_history.lifestyle.substances.substance_quantity_label.cocaine",
  },
  hookah: {
    titleKey: "med_history.lifestyle.substances.substance_title.hookah",
    contextLabelKey:
      "med_history.lifestyle.substances.substance_context_label.hookah",
    quantityLabelKey:
      "med_history.lifestyle.substances.substance_quantity_label.hookah",
  },
  other: {
    titleKey: "med_history.lifestyle.substances.substance_title.other",
    contextLabelKey:
      "med_history.lifestyle.substances.substance_context_label.other",
    quantityLabelKey:
      "med_history.lifestyle.substances.substance_quantity_label.other",
  },
};
